import type { ReactNode } from "react";

interface BadgeProps {
  children: ReactNode;
  icon?: ReactNode;
  className?: string;
}

export function Badge({ children, icon, className = "" }: BadgeProps) {
  return (
    <span
      className={`inline-flex items-center gap-2.5 rounded-full border border-white/10 bg-white/5 px-5 py-2 text-xl font-medium uppercase tracking-widest text-white/70 backdrop-blur-xl ${className}`}
    >
      {icon}
      {children}
    </span>
  );
}
